<template>
  <div>
    <b-media
      class="mb-md-3 bg-form-header d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center p-md-2 p-1 rounded"
      no-body
    >
      <div class="d-flex justify-content-start align-items-center mt-sm-0 mt-2">
        <b-media-aside class="mr-1">
          <b-avatar size="45" class="rounded-avatar bg-secondary" />
        </b-media-aside>
        <b-media-body class="d-flex align-items-center text-white">
          <h4 class="font-weight-bolder text-white mb-0">Partner conditions</h4>
          <feather-icon
            icon="HelpCircleIcon"
            size="16"
            class="font-weight-bolder ml-1 rounded-circle cursor-pointer"
            v-b-tooltip.hover="'Partner conditions'"
          />
        </b-media-body>
      </div>
      <b-link :to="{ name: 'competitions' }">
        <span>back to the competitio list </span>
        <feather-icon icon="ChevronRightIcon"
      /></b-link>
    </b-media>
    <div class="px-sm-5 pt-1 w-100 px-2">
      <p class="font-weight-bolder">
        If you have further conditions for participants, write them below:
      </p>
      <div
        class="d-flex justify-content-between align-items-center w-100 flex-wrap"
      >
        <p class="font-weight-bolder text-warning mb-sm-0">
          for example: follow @sponsorname on instagram.
        </p>
        <b-button @click="addCondition" variant="primary"
          >Add conditions</b-button
        >
      </div>
    </div>
    <b-row class="justify-content-center px-2">
      <b-col md="9" v-for="(condition, index) in conditions" :key="index">
        <b-form-group
          :label="`${index + 1}.`"
          label-for="1-partner"
          label-cols-md="1"
        >
          <validation-provider
            #default="{ errors }"
            name="condition"
            :vid="`${index}-partner`"
            class="w-100"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-textarea
                :id="`${index}-partner`"
                v-model="conditions[index]"
                class="col-10"
              />
              <div class="col-2">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  v-b-tooltip.hover="'Delete condition'"
                  @click="removeCondition(index)"
                >
                  <feather-icon icon="XCircleIcon"
                /></b-button>
              </div>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BCardHeader,
  BBadge,
  BButton,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardBody,
  BImg,
  BForm,
  BFormGroup,
  BFormTextarea,
  VBTooltip,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BCardHeader,
    BBadge,
    BButton,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardBody,
    BImg,
    BForm,
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BLink,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      conditions: [""],
    };
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    competition(val) {
      this.conditions = val.conditions;
    },
    conditions(val) {
      this.$emit("partnerConditions", { conditions: [...val] });
    },
  },
  methods: {
    addCondition() {
      this.conditions.push("");
    },
    removeCondition(i) {
      this.conditions.splice(i, 1);
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 0px !important;
}
</style>
